import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Box,
    Link,
    Divider,
    Slide,
    useScrollTrigger,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';

import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';

function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}

const Header = ({ onThemeToggle, darkMode }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };
    const menuItems = [
        // { text: 'Home', path: '/' },
        { text: 'Sobre mim', path: '#aboutMe' },
        { text: 'Stacks', path: '#skills' },
        { text: 'Projetos', path: '#projects' },
    ];

    const textColor = darkMode ? '#f5f5f5' : '#0E0E0F';
    const backgroundColor = darkMode ? '#0E0E0F' : '#f5f5f5';

    return (
        <React.Fragment>
            <HideOnScroll>
                <AppBar height={'64px'} sx={{ color: textColor, backgroundColor: backgroundColor }}>
                    <Toolbar>
                        {' '}
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{ flexGrow: 1 }}
                            id="back-to-top-anchor"
                        >
                            Ítalo Matos
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ display: { xs: 'block', md: 'none' } }}
                            onClick={toggleDrawer(true)}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                            {menuItems.map((item) => (
                                <Typography
                                    key={item.text}
                                    component={Link}
                                    href={item.path}
                                    sx={{ color: 'inherit', marginLeft: 2, textDecoration: 'none' }}
                                    fontWeight={500}
                                >
                                    {item.text}
                                </Typography>
                            ))}

                            {
                                <IconButton
                                    edge="end"
                                    color="inherit"
                                    aria-label="theme-toggle"
                                    onClick={onThemeToggle}
                                    sx={{
                                        transition: 'transform 1s ease, color 1s ease', // Adiciona transição suave
                                        transform: darkMode ? 'rotate(0deg)' : 'rotate(360deg)', // Gira o ícone ao alternar
                                    }}
                                >
                                    {darkMode ? (
                                        <WbSunnyRoundedIcon
                                            sx={{ color: '#efe503', transition: 'color 1s ease' }}
                                        />
                                    ) : (
                                        <DarkModeRoundedIcon
                                            sx={{ color: '#1a237e', transition: 'color 1s ease' }}
                                        />
                                    )}
                                </IconButton>
                            }
                        </Box>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
            <Toolbar />
            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box sx={{ textAlign: 'end' }} p={1}>
                    <CloseIcon fontSize="large" onClick={toggleDrawer(false)} />
                </Box>

                <Box sx={{ width: 250 }} role="presentation" onKeyDown={toggleDrawer(false)}>
                    <Divider />

                    <List>
                        {menuItems.map((item) => (
                            <ListItem key={item.text} component={Link} href={item.path}>
                                <ListItemText primary={item.text} />
                            </ListItem>
                        ))}
                    </List>

                    <Divider />

                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="theme-toggle"
                        onClick={onThemeToggle}
                        sx={{
                            transition: 'transform 1s ease, color 1s ease', // Adiciona transição suave
                            transform: darkMode ? 'rotate(0deg)' : 'rotate(360deg)', // Gira o ícone ao alternar
                        }}
                    >
                        {darkMode ? (
                            <WbSunnyRoundedIcon
                                sx={{ color: '#efe503', transition: 'color 1s ease' }}
                            />
                        ) : (
                            <DarkModeRoundedIcon
                                sx={{ color: '#1a237e', transition: 'color 1s ease' }}
                            />
                        )}
                    </IconButton>

                    {/* TODO: Add download CV button */}
                    {/* <Divider /> */}
                    {/* <Box>
                        <Button variant="contained" color="primary" sx={{ margin: 2 }}>
                            Download CV
                        </Button>
                    </Box> */}
                </Box>
            </Drawer>
        </React.Fragment>
    );
};

export default Header;
